import React from 'react';
import { Minus, Plus } from 'lucide-react';
import { toBengaliNumeral } from '../utils/bengaliHelpers';
interface PassengerStepperProps {
  label: string;
  subLabel?: string;
  value: number;
  onChange: (val: number) => void;
  min?: number;
  max?: number;
}
export function PassengerStepper({
  label,
  subLabel,
  value,
  onChange,
  min = 0,
  max = 10
}: PassengerStepperProps) {
  return <div className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0" data-id="element-48">
      <div data-id="element-49">
        <p className="font-medium text-gray-900 font-bengali text-lg" data-id="element-50">
          {label}
        </p>
        {subLabel && <p className="text-sm text-gray-500 font-bengali" data-id="element-51">{subLabel}</p>}
      </div>
      <div className="flex items-center space-x-4" data-id="element-52">
        <button onClick={() => value > min && onChange(value - 1)} disabled={value <= min} className={`w-10 h-10 rounded-full flex items-center justify-center border ${value <= min ? 'border-gray-200 text-gray-300' : 'border-[#006a4e]/20 text-[#006a4e] bg-[#006a4e]/5 active:bg-[#006a4e]/10'}`} aria-label="Decrease" data-id="element-53">
          <Minus size={20} data-id="element-54" />
        </button>

        <span className="w-8 text-center font-bold text-xl font-bengali" data-id="element-55">
          {toBengaliNumeral(value)}
        </span>

        <button onClick={() => value < max && onChange(value + 1)} disabled={value >= max} className={`w-10 h-10 rounded-full flex items-center justify-center border ${value >= max ? 'border-gray-200 text-gray-300' : 'border-[#006a4e] text-white bg-[#006a4e] active:bg-[#004d38]'}`} aria-label="Increase" data-id="element-56">
          <Plus size={20} data-id="element-57" />
        </button>
      </div>
    </div>;
}